export const PREFERRED_MINIMUM_RATE_PER_MILE = 1.99;

const parseStoredBoolean = (raw, defaultValue = false) => {
    if (raw === null || raw === undefined || raw === "" || raw === "undefined") {
        return defaultValue;
    }
    try {
        const parsed = JSON.parse(raw);
        if (typeof parsed === "boolean") return parsed;
        if (parsed === "true" || parsed === true) return true;
        if (parsed === "false" || parsed === false) return false;
        return defaultValue;
    } catch (_) {
        if (raw === "true") return true;
        if (raw === "false") return false;
        return defaultValue;
    }
};

export function addCompanyToCompanyList(parsedCurrentList, newCompany){
    parsedCurrentList.push({
        "firstDayOfAWeek": newCompany.firstDayOfAWeek,
        "companyName": newCompany.companyName,
        "id": newCompany.id,
        "ownerLeasePayoutFollowsWeeklyRateDistribution": newCompany.ownerLeasePayoutFollowsWeeklyRateDistribution === true,
        "truckStatusColumnEnabled": resolveTruckStatusColumnEnabled(newCompany),
    })
    localStorage.setItem('accessibleCompanies', JSON.stringify(parsedCurrentList));
}
export const setCompany = (e) => {
    localStorage.setItem('currentCompanyId', e.id);
    localStorage.setItem('currentCompanyName', e.companyName);
    localStorage.setItem('currentFirstDayOfAWeek', e.firstDayOfAWeek);
    localStorage.setItem('hosCalculation', e.hosCalculation ? JSON.stringify(e.hosCalculation) : e.hosCalculation);
    localStorage.setItem('defaultTimezone', e.defaultTimezone || "America/Chicago");
    localStorage.setItem('mainlyOperatesWithSolo', e.mainlyOperatesWithSolo === null || e.mainlyOperatesWithSolo === undefined ? true : e.mainlyOperatesWithSolo);
    localStorage.setItem(
        'ownerLeasePayoutFollowsWeeklyRateDistribution',
        JSON.stringify(e.ownerLeasePayoutFollowsWeeklyRateDistribution === true)
    );
    localStorage.setItem(
        'truckStatusColumnEnabled',
        JSON.stringify(resolveTruckStatusColumnEnabled(e))
    );
}

/** On unless the company turned it off. Missing value is off only for company ids 1 and 2. */
export function resolveTruckStatusColumnEnabled(company) {
    const raw = company?.truckStatusColumnEnabled;
    if (raw === false || raw === 'false') return false;
    if (raw === true || raw === 'true') return true;
    const id = Number(company?.id);
    if (id === 1 || id === 2) return false;
    return true;
}

export const truckStatusColumnEnabledFromCompany = (company = retrieveCompanyData()) =>
    resolveTruckStatusColumnEnabled(company);

export const retrieveCompanyData = () => {
    const hosCalculation = localStorage.getItem("hosCalculation");
    return {
        id : localStorage.getItem("currentCompanyId"),
        companyName: localStorage.getItem("currentCompanyName"),
        firstDayOfAWeek: localStorage.getItem("currentFirstDayOfAWeek"),
        hosCalculation: hosCalculation && hosCalculation !== "undefined" ? JSON.parse(hosCalculation) : null,
        defaultTimezone: localStorage.getItem("defaultTimezone"),
        mainlyOperatesWithSolo: localStorage.getItem("mainlyOperatesWithSolo"),
        ownerLeasePayoutFollowsWeeklyRateDistribution: parseStoredBoolean(
            localStorage.getItem("ownerLeasePayoutFollowsWeeklyRateDistribution"),
            false
        ),
        truckStatusColumnEnabled: localStorage.getItem("truckStatusColumnEnabled") == null
            ? undefined
            : parseStoredBoolean(localStorage.getItem("truckStatusColumnEnabled"), true),
    }
}

export const removeCompanyData = () => {
    localStorage.removeItem('currentCompanyId');
    localStorage.removeItem('currentCompanyName');
    localStorage.removeItem('currentFirstDayOfAWeek');
    localStorage.removeItem('hosCalculation');
    localStorage.removeItem('defaultTimezone');
    localStorage.removeItem('ownerLeasePayoutFollowsWeeklyRateDistribution');
    localStorage.removeItem('truckStatusColumnEnabled');
}
